var ProductPriceRange = /** @class */ (function () {
    function ProductPriceRange(siteStore) {
        this.siteStore = siteStore;
    }
    ProductPriceRange.prototype.shouldShowPriceRange = function () {
        return Boolean(this.siteStore.priceSettings.showPriceRange);
    };
    return ProductPriceRange;
}());
export { ProductPriceRange };
//# sourceMappingURL=ProductPriceRange.js.map